module.exports = __webpack_public_path__ + "static/media/srijannit.9c936123.png";